import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const AlertFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function AlertFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="m22.62 16.815-7.64-13.1c-1.33-2.28-4.63-2.28-5.96 0l-7.64 13.1c-1.34 2.3.32 5.18 2.98 5.18h15.28c2.66 0 4.32-2.89 2.98-5.18ZM13 6.995h-2v6.5h2v-6.5Zm.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default AlertFilled;